import * as React from "react";
import { Box, Flex } from "@quandoo-dev/cookbook/lib/layout";
import { Body } from "@quandoo-dev/cookbook/lib/typography";
import styled from "styled-components";
import { themeGet as $ } from "@styled-system/theme-get";

// TODO: request exported icons for each social metwork
// import FacebookIcon from '../../assets/facebook-icon.inline.svg';
import FacebookIcon from "../../assets/facebook-icon-1.inline.svg";
import TwitterIcon from "../../assets/instagram-icon-1.inline.svg";
import LinkedinIcon from "../../assets/linkedin-icon-1.inline.svg";
import useTranslation from "../../hooks/useTranslation";

const List = styled(Flex)`
  list-style: none;

  li {
    margin-right: ${$("space.xs")};
  }
`;

interface ShareProps {
  locale: { domain: string, slug: string };
  title: string;
  description: string;
  url: string;
  country: string;
}

const Share: React.FC<ShareProps> = ({locale, title, description, url, country}) => {
  const shareText = useTranslation(country, "post.share");
  const SHARE_OPTIONS = [
    {
      name: "facebook",
      icon: <a href={"https://www.facebook.com/sharer/sharer.php?u=" + url} target="_blank"><FacebookIcon /></a>,
    },
    {
      name: "twitter",
      icon: <a href={"http://twitter.com/share?text=" + title + "&url=" + url} target="_blank"><TwitterIcon /></a>,
    },
    {
      name: "linkedin",
      icon: <a href={"https://www.linkedin.com/shareArticle?mini=true&url=" +  url + "&title=" + title + "&summary=" + description + "&source=Quisine"} target="_blank"><LinkedinIcon /></a>,
    },
  ];
  return (
    <Box mt="md">
      <Body size="xs" mb="xxs">
        {shareText}:
      </Body>
      <List>
        {SHARE_OPTIONS.map(({ name, icon }) => (
          <li key={name}>{icon}</li>
        ))}
      </List>
    </Box>
  );
};

export default Share;
